import React from "react";
import PropTypes from "prop-types";

import Chat from "../../components/Chat";

export default class HqPage extends React.Component {
  static propTypes = {
    token: PropTypes.string
  };

  render() {
    return (
      <Chat
        token={this.props.token}
        url="chat/supporters_chatroom"
        room="supporters_chatroom"
        show_input={true}
      />
    );
  }
}
